import { createSlice } from "@reduxjs/toolkit";

export const barSlice = createSlice({
  name: "bar",
  initialState: {
    open: false,
  },
  reducers: {
    setOpen: (state, action) => {
      return {
        ...state,
        open: action.payload,
      };
    },
  },
});

export const { setOpen } = barSlice.actions;

export default barSlice.reducer;
